module.exports = __webpack_public_path__ + "img/defended-pc.7f274386.png";